// Modal dialog frame shared by the disOS dialogs (Escape closes, click outside closes).
import { useEffect, type ReactNode } from 'react';

export function Dlg({ title, size = '', onClose, children, footer }: { title: string; size?: '' | 'sm' | 'md'; onClose: () => void; children: ReactNode; footer?: ReactNode }) {
  useEffect(() => {
    const k = (e: KeyboardEvent) => { if (e.key === 'Escape') { e.stopPropagation(); onClose(); } };
    window.addEventListener('keydown', k, true);
    return () => window.removeEventListener('keydown', k, true);
  }, [onClose]);
  return (
    <div className="scrim" onMouseDown={(e) => { if (e.target === e.currentTarget) onClose(); }}>
      <div className={`dlg${size ? ` ${size}` : ''}`} role="dialog" aria-modal="true" aria-label={title}>
        <header><h2>{title}</h2><button type="button" className="x" aria-label="Close" onClick={onClose}>×</button></header>
        {children}
        {footer && <footer>{footer}</footer>}
      </div>
    </div>
  );
}
